import { Component, OnInit, Inject } from '@angular/core';
import { AuthService } from "../core/auth/auth.service";
import { AppConfig } from 'src/config/app.config';

@Component({
  selector: 'app-healthcheck',
  templateUrl: './healthcheck.component.html',
  styleUrls: ['./healthcheck.component.css']
})
export class HealthcheckComponent implements OnInit {
  private _apiUrl: string;
  clientList: any;
  healthCheckMsg: string;

  constructor(private authService: AuthService, private appConfig : AppConfig) { 
    this._apiUrl = appConfig.baseUrl;
  }

  ngOnInit(): void {
    this.authService.get(this._apiUrl + '/api/v1/Client').subscribe(response => {
      if (response) {
        this.healthCheckMsg = "Healthy"
      }
      else{
       this.healthCheckMsg = "Unhealthy" 
      }
    }, (error) => {
      console.error(error);
    });
  }

}
